import React from 'react';
import { useMutation } from '@tanstack/react-query';
import { tenantApi, Integration, IntegrationRequest } from '../lib/tenant-api';
import { toast } from 'react-toastify';
import {
  ShopifyConfig,
  GoogleDriveConfig,
  WebflowConfig,
  HubspotConfig,
  SalesforceConfig,
  WordpressConfig
} from './integrations';

interface IntegrationConfigModalProps {
  isOpen: boolean;
  onClose: () => void;
  integration?: Integration | null;
  onSuccess: () => void;
  integrationType: string;
}

const IntegrationConfigModal: React.FC<IntegrationConfigModalProps> = ({
  isOpen,
  onClose,
  integration,
  onSuccess,
  integrationType
}) => {

  const createIntegrationMutation = useMutation({
    mutationFn: tenantApi.createIntegration,
    onSuccess: () => {
      toast.success(`${integrationType} integration created successfully!`);
      onSuccess();
    },
    onError: (error: any) => {
      toast.error(`Failed to create integration: ${error.response.data.detail}`);
    },
  });

  const updateIntegrationMutation = useMutation({
    mutationFn: ({ id, data }: { id: string; data: IntegrationRequest }) =>
      tenantApi.updateIntegration(id, data),
    onSuccess: () => {
      toast.success(`${integrationType} integration updated successfully!`);
      onSuccess();
    },
    onError: (error: any) => {
      toast.error(`Failed to create integration: ${error.response.data.detail}`);
    },
  });

  if (integrationType === 'wordpress') {
    return <WordpressConfig isOpen={isOpen} onClose={onClose} integration={integration} createIntegrationMutation={createIntegrationMutation} updateIntegrationMutation={updateIntegrationMutation} />;
  }

  if (integrationType === 'google_drive') {
    return <GoogleDriveConfig isOpen={isOpen} onClose={onClose} integration={integration} createIntegrationMutation={createIntegrationMutation} updateIntegrationMutation={updateIntegrationMutation} />;
  }

  if (integrationType === 'shopify') {
    return <ShopifyConfig isOpen={isOpen} onClose={onClose} integration={integration} createIntegrationMutation={createIntegrationMutation} updateIntegrationMutation={updateIntegrationMutation} />;
  }

  if (integrationType === 'webflow') {
    return <WebflowConfig isOpen={isOpen} onClose={onClose} integration={integration} createIntegrationMutation={createIntegrationMutation} updateIntegrationMutation={updateIntegrationMutation} />;
  }

  if (integrationType === 'hubspot') {
    return <HubspotConfig isOpen={isOpen} onClose={onClose} integration={integration} createIntegrationMutation={createIntegrationMutation} updateIntegrationMutation={updateIntegrationMutation} />;
  }

  if (integrationType === 'salesforce') {
    return <SalesforceConfig isOpen={isOpen} onClose={onClose} integration={integration} createIntegrationMutation={createIntegrationMutation} updateIntegrationMutation={updateIntegrationMutation} />;
  }

  return null;

};

export default IntegrationConfigModal;
